(function() {
    'use strict';

    angular
        .module('atheer.conversation', [

        ]);
})();
